<template>
  <div class="main">

    <div class="overlay-compleanno" v-show="showPopupCompleanno" v-on:click="showPopupCompleanno=false">
      <div class="overlay-popup-complanno" v-show="showPopupCompleanno">
        <img class="img_birthday" src="../assets/images/birthday-cake.svg">
        <div class="popup_text">
          <span class="popup_title">Buon compleanno<br>da Life!</span>
        </div>
      </div>
    </div>

    <div id="homepage">
      <HomeProfile v-on:iconMoreClick="onIconMoreClick"></HomeProfile>

      <div>
        <div class="overlay-search" v-show="searchResults.length" v-on:tap="searchFeature=''"></div>
        <div class="search-box">
          <input
            ref="input"
            type="text"
            name="cerca"
            value
            placeholder="Cerca contenuto"
            v-model="searchFeature"
            id="input"
            v-on:tap="scrollSearch()"
          />
          <i v-on:tap="searchButtonClicked()" class="rds-icon rds-icon-search"></i>
        </div>
        <section class="search-results search-results-home" v-show="searchResults.length">
          <!-- <div
            class="search-result"
            v-for="(result, i) in searchResults"
            v-bind:key="i"
          >{{result.name}}</div>-->
          <ContactCard
            v-bind:userContact="result"
            v-for="(result, i) in searchResults"
            v-bind:key="i"
          ></ContactCard>
        </section>
      </div>

      <div v-show="!searchResults.length">
        <section>
          <h4>Menu</h4>
          <div id="sezioni-box">
            <div id="sezioni" v-scrollSnap="{childWidth:128}">
              <FeatureCard
                v-on:tap.native="goTo(feature.url);"
                v-bind:label="feature.name"
                v-for="feature in filteredFeatures"
                v-bind:key="feature.name"
              ></FeatureCard>
              <FeatureCard style="padding-right: 30px;" label></FeatureCard>
            </div>
          </div>
        </section>
        <section>
          <h4>Eventi</h4>
          <div id="eventi-box">
            <HomeEvent v-bind:event="event" v-for="event in events" v-bind:key="event.id"></HomeEvent>
          </div>
        </section>
        <section class="life-social-rds">
          <h4>Seguici su:</h4>
          <div id="eventi-box-facebok">
            <span
              v-on:tap="openLink('https://www.facebook.com/rds.grandisuccessi')"
              target="_blank"
            >
              <img class="life-icon-social" src="../assets/rds-life-fonticons/facebook.svg" />
            </span>
            <span v-on:tap="openLink('https://www.instagram.com/lifeatrds/?hl=it')" target="_blank">
              <img class="life-icon-social" src="../assets/rds-life-fonticons/instagram.svg" />
            </span>
            <span v-on:tap="openLink('https://twitter.com/RDS_official')" target="_blank">
              <img class="life-icon-social" src="../assets/rds-life-fonticons/twitter.svg" />
            </span>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import HomeProfile from '@/components/HomeProfile.vue';
// import RdsMenu from '@/components/RdsMenu';
import HomeEvent from '@/components/HomeEvent';
import FeatureCard from '@/components/FeatureCard.vue';
// import ImageCropper from '../components/ImageCropperNew';
// import mocker from '../services/Mocker.service';
import userService from '../services/User.service';
import cookieService from '../services/Cookies.service';
import calendarService from '../services/Calendar.service';
import config from '../config';
import { eventBus } from '../services/EventBus';
import store from '../stores';
import RestStore from '../stores/RestStore';
import memoryStore from '../stores/MemoryStore';
import ContactCard from '../components/ContactCard';
import scrollSnap from '../directives/scrollSnap';
const restStore = new RestStore();
// function getUsers() {
//   let users = mocker.getMockedData('RdsUsers').users;
//   return users;
// }

export default {
  name: 'home',
  components: {
    HomeProfile,
    FeatureCard,
    HomeEvent,
    // ImageCropper,
    ContactCard
    // RdsMenu
  },
  directives: {
    scrollSnap
  },
  data() {
    return {
      users: [],
      searchUser: '',
      events: [],
      searchFeature: '',
      editImageMode: false,
      editableImage: null,
      hideRomeFeatures: true,
      showPopupCompleanno: false
    };
  },
  methods: {
    scrollSearch() {
      // setTimeout(function() {
      //   document.getElementsByClassName('main')[0].scroll(0, document.getElementsByClassName('search-box')[0].offsetTop);
      // }, 2000);
    },
    openLink(uri) {
      if (window.cordova) {
        // window.cordova.InAppBrowser.open(uri, '_system');
        window.cordova.InAppBrowser.open(uri, '_blank');
      } else {
        window.open(uri, '_blank');
      }
    },
    goTo(route) {
      let userFeatures = (cookieService.getCookie('userFeatures') || []).filter(
        uf => uf !== route
      );
      userFeatures.push(route);
      cookieService.setCookie('userFeatures', userFeatures, 100);
      if (route.indexOf('http') === 0) {
        window.open(route, '_blank');
      } else {
        this.$router.push(route);
      }
    },
    searchButtonClicked() {
      if (this.searchResults.length) {
        return;
      }
      const filteredFeatures = this.filteredFeatures;
      if (this.searchFeature.length && filteredFeatures.length) {
        this.goTo(filteredFeatures[0].url);
      }
    },
    backButtonClicked() {
      this.searchFeature = '';
    },
    editImage(editableImage) {
      console.log('editImageMode');

      this.editableImage = editableImage;
      this.editImageMode = true;
    },
    onIconMoreClick() {
      eventBus.$emit('toogleMenuProfile');
    },
    onCroppedImg(cropImg) {
      const filename =
        userService.user.name.toLowerCase().replace(/\s+/g, '') +
        new Date().getTime() +
        '.png';
      console.log('filename', filename);

      eventBus.$emit('updating');
      restStore
        .getUploadUrl(cropImg, 'image/png', filename)
        .then(response => response.json())
        .then(resp => {
          console.log(resp.url);
          const param =
            Math.random()
              .toString(36)
              .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15);
          userService.user.photos[0] = `https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/${filename}?v=${param}`;
          restStore.uploadFile(resp.url, 'image/png', cropImg);
        })
        .then(() => {
          store
            .update('rdsUser', userService.user.id, userService.user)
            .then(u => {
              wait(1000).then(() => {
                userService.user = u;
                eventBus.$emit('updated');
                this.$router.push('/');
                this.editImageMode = false;
                if (!!memoryStore.editableImage) {
                  delete memoryStore.editableImage;
                }
              });
            })
            .catch(e => {
              console.warn(e);
              eventBus.$emit('updated');
              this.editImageMode = false;
              if (!!memoryStore.editableImage) {
                delete memoryStore.editableImage;
              }
            });
        })
        .catch(e => {
          console.warn(e);
          eventBus.$emit('updated');
          this.editImageMode = false;
        });

      // eventBus.$emit('updating');
      // store
      //   .update('rdsUser', this.currentUser.id, this.currentUser)
      //   .then(u => {
      //     userService.user = u;
      //     eventBus.$emit('updated');
      //     this.editImageMode = false;
      //   })
      //   .catch(e => {
      //     console.warn(e);
      //     eventBus.$emit('updated');
      //     this.editImageMode = false;
      //   });
    },
    searchUsers(searchString, users) {
      let searchRes = users.filter(u => {
        let contactValues = [];
        try {
          contactValues = u.contacts.map(c => c.value);
        } catch (error) {
          console.warn(error);
        }

        return (
          u.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 ||
          contactValues.find(
            cv => cv.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
          )
        );
      });
      for (let i = 0; i < searchRes.length; i++) {
        searchRes[i].name = searchRes[i].name
          .replace('undefined ', '')
          .replace(' undefined', '')
          .replace('undefined', '');
      }
      console.log(searchRes);

      return searchRes;
    },
    geolocationSuccess(position) {
      console.log(position);
      if (
        position.coords.latitude > 44 ||
        position.coords.latitude < 40 ||
        position.coords.longitude < 11 ||
        position.coords.longitude > 15
      ) {
        this.hideRomeFeatures = true;
      } else {
        this.hideRomeFeatures = false;
      }

      // 41.928211, 12.433186
    },
    formatDate() {
      let d = new Date();
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    }
  },
  mounted() {
    if (!!window.cordova) {
      navigator.geolocation.getCurrentPosition(this.geolocationSuccess);
    } else {
      this.hideRomeFeatures = false;
    }

    // Verifica compleanno
    let dnascita = userService.user.info.find(o => o.key === 'Data di Nascita');
    if (dnascita) {
      if ((localStorage.getItem('lastCompleanno') !== this.formatDate()) && (dnascita.value.slice(5) === this.formatDate().slice(5))) {
        console.log('compleanno', "E' il tuo compleanno");
        this.showPopupCompleanno = true;
        localStorage.setItem('lastCompleanno', this.formatDate());
      }
      console.log('compleanno', dnascita.value.slice(5), this.formatDate().slice(5));
    }

    this.$refs.input.oninput = e => {
      if (e.inputType === 'insertCompositionText' && !!e.data) {
        this.searchFeature = e.data;
      } else if (e.inputType === 'insertCompositionText' && e.data === null) {
        this.searchFeature = '';
      }
    };
    eventBus.$emit('showBellButton');
    if (this.$route.name === 'editImage' && !!memoryStore.editableImage) {
      this.editImage(memoryStore.editableImage);
    }
    const usersPromise = store.getAll('rdsUser');
    usersPromise.then(users => {
      this.users = users;
      window.users = users;
      localStorage.setItem('users', JSON.stringify(this.users));
      if (memoryStore.events && memoryStore.events.length) {
        this.events = memoryStore.events;
      } else {
        calendarService.getGCalendarEvents(users).then(events => {
          this.events = events;
        });
      }
    });
  },
  computed: {
    searchResults() {
      if (this.searchFeature.trim().length < 1) {
        return [];
      } else {
        return this.searchUsers(this.searchFeature, this.users);
      }
    },
    features() {
      const userFeatures = cookieService.getCookie('userFeatures');
      let features = config.features;
      console.log('User Features:', userFeatures);
      /* if (!!userFeatures) {
        features.sort(
          (a, b) => userFeatures.indexOf(b.url) - userFeatures.indexOf(a.url)
        );
      } */
      return features;
    },
    filteredList() {
      return this.users.filter(
        u =>
          JSON.stringify(u)
            .toLowerCase()
            .indexOf(this.searchUser) !== -1
      );
    },
    filteredFeatures() {
      if (this.hideRomeFeatures) {
        return this.features.filter(f => !f.romeOnly);
      }
      return this.features;
      // return this.searchFeature.length > 1
      //   ? this.features.filter(
      //       f =>
      //         f.name.toLowerCase().indexOf(this.searchFeature.toLowerCase()) !==
      //         -1
      //     )
      //   : this.features;
    }
  },
  watch: {
    searchFeature: function(val, oldVal) {
      if (val.length > 0 && oldVal.length === 0) {
        eventBus.$emit('showBackButton');
      } else if (val.length === 0) {
        eventBus.$emit('hideBackButton');
      }
    }
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Home back');
      this.backButtonClicked();
    });
    eventBus.$on('editMode', image => {
      this.editImage(image);
    });
  },
  destroyed() {
    eventBus.$emit('hideBellButton');
    eventBus.$emit('hideBackButton');
    eventBus.$off('backButtonClicked');
  }
};
function wait(milliseconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}
</script>
<style lang="scss" scoped>
#homepage #result-container {
  background-color: #fff;
  margin: 0 21px;
  position: relative;
  top: -10px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.05);
  max-height: 580px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
#eventi-box-facebok {
  margin: 13px 26px 14px 11px;
}
.search-result {
  display: flex;
}

#homepage .search-result .img-result {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 53px;
  img {
    width: 100%;
  }
}

#homepage .search-result p {
  // font-size: 30pt;
  font-weight: 600;
}

#sezioni {
  -webkit-overflow-scrolling: touch;
}

.header-image-container {
  max-height: 192px;
  transition: 'max-heigth' 0.4;
}
.show-results .header-image-container {
  max-height: 0;
}
.search-results {
  margin: 21px 21px 0;
  & /deep/ .contact-box {
    margin: 0;
  }
}
.search-results-home {
  max-height: calc(100vh - 445px);
  min-height: 50px;
  overflow-y: auto;
  z-index: 1;
  position: relative;
  background-color: #ffffff;
}
.life-social-rds {
  display: flex;
  flex-direction: row;
  margin-bottom: 7%;

  span {
    display: inline-flex;
    padding: 15px;
    margin: -15px 0;
  }
}
.life-icon-social {
  width: 28px;
}
.overlay-search {
  background-color: black;
  width: 100%;
  height: 100vh;
  opacity: 0.4;
  position: absolute;
  top: 0;
  z-index: 1;
  /*display: none;*/
}
.search-box {
  z-index: 1;
  position: relative;
  padding: 0;
}
#input {
  /*padding: 14px 0;*/
  height: 44px;
}
  /****POPUP COMPLEANNO***/
.overlay-compleanno{
  background-color: rgba(255,255,255,.8);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}
.overlay-popup-complanno{
  background-image: url("../assets/images/mensa/background_popup_mensa.svg");
  position: relative;
  width: 80%;
  height: calc(100% - 210px);
  z-index: 3;
  /*max-width: 442px;*/
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  /* left: 10%; */
  /*max-height: 330px;*/
  margin: 50px auto;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.img_birthday{
  display: block;
  margin: 0 auto;
  width: 50%;
  margin-top: 10%;
  /*max-width: 50px;*/
}
.popup_text{
  margin: 0 auto;
  max-width: 500px;
  padding-top: 10%;
  text-align: center;
  color: #ffffff;
}
.popup_title{
  font-size: 1.07em;
  font-weight: 600;
  letter-spacing: 1px;
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}
.popup_text_detail{
  font-size: 0.9em;
  font-weight: 300;
  letter-spacing: 1px;
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}
</style>
